@if (isLoading()) {
  <div class="position-relative">
    <div class="row h-100 m-3">
      <div
        class="col-12 text-center d-flex align-items-center justify-content-center"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ 'common.loading' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="modal-content m-0">
    <div class="modal-header">
      <p class="mb-0">{{ 'reports.approve.title' | translate }}</p>
      <i
        class="fa-light fa-xmark ms-auto cursor-pointer"
        (click)="modalRef.dismiss()"
      ></i>
    </div>

    @if (step() === DialogStep.prepareEmail) {
      <app-approve-report-prepare-email
        [kitId]="kitId()"
        [report]="$any(report())"
        [notificationProfile]="notificationProfile()"
        [templateType]="templateType()"
        [emailTemplate]="emailTemplate()"
        [isLoading]="isLoading()"
        (isLoadingChange)="isLoading.set($event)"
        (emailConfig)="setEmailConfig($event)"
      />
    } @else if (step() === DialogStep.previewEmail) {
      <app-approve-report-preview-email
        [emailConfig]="emailConfig()"
        [notificationProfile]="notificationProfile()"
        [templateType]="templateType()"
        (sendEmail)="sendEmail($event)"
      />
    } @else if (step() === DialogStep.approveReport) {
      <app-approve-report
        [report]="$any(report())"
        [kitId]="kitId()"
        (approveReport)="approveReport($event)"
      />
    }
  </div>
}
